import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Lista from "./Lista";
import PlanoAulas from "./PlanoAulas";
// import Produto from "./Produto";
// import DuplicarProduto from "./DuplicarProduto";

const IndexPacote = ({ match, history }) => (
  <div className="content-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/lista`} />
      <Route path={`${match.url}/lista`} component={Lista} />
      <Route path={`${match.url}/:id`} component={PlanoAulas} />
      {/* <Route path={`${match.url}/item/:id`} component={Produto} />
      <Route
        exact
        path={`${match.url}/produto-duplicacao/:id`}
        component={DuplicarProduto}
      /> */}
    </Switch>
  </div>
);

export default IndexPacote;
